import { motion } from "framer-motion";
import logo from "../assets/logo.png";
import { useEffect, useState } from "react";
import {
  containerVariants,
  xiongVariants,
  textVariants,
  shapeVariants,
} from "./Variants";
import { decideReveal } from "../revealPolicy";
import { getDragonLoadState, subscribeDragonGeometry } from "../dragonAsset";

const WORDS = ["Hello", "I", "Am", "Chris Xiong"];

const PreLoader = ({ setLoading }) => {
  const [index, setIndex] = useState(0);

  /* The exit used to be a bare 3.5s timer that knew nothing about whether the
     site behind it was ready. It now asks the policy, which still runs the
     animation for its full length but can hold a moment longer for a dragon
     that is nearly there - and refuses to hold for one that is not. */
  useEffect(() => {
    const startedAt = Date.now();
    let timer;
    let unsubscribe;

    const check = () => {
      clearTimeout(timer);
      const { reveal, waitMs } = decideReveal(
        Date.now() - startedAt,
        getDragonLoadState(),
      );
      if (reveal) {
        setLoading(false);
        return;
      }
      // waitMs is exactly when the answer could next change, so this re-checks
      // at the two decision points rather than polling.
      timer = setTimeout(check, waitMs);
    };

    // A model that lands mid-grace should cut the wait short immediately.
    unsubscribe = subscribeDragonGeometry(() => {
      clearTimeout(timer);
      check();
    });
    check();

    return () => {
      clearTimeout(timer);
      if (unsubscribe) unsubscribe();
    };
  }, [setLoading]);

  useEffect(() => {
    if (index === WORDS.length - 1) return undefined;

    const timer = setTimeout(
      () => {
        setIndex(index + 1);
      },
      index === 0 ? 1500 : 400,
    );
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <motion.div
      /* Above the navbar's z-[60]: the site is now mounted underneath this
         overlay rather than after it, so the overlay has to cover all of it. */
      className="fixed inset-0 flex z-[100] items-center
      overflow-hidden justify-center bg-black"
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
    >
      <motion.div className="flex flex-col items-center justify-center">
        {index < 3 && (
          <motion.span
            className="text-white px-5 text-5xl font-bold"
            variants={textVariants}
          >
            {WORDS[index]}
          </motion.span>
        )}
        {index === 3 && (
          <motion.span
            variants={xiongVariants}
            className="px-5 text-5xl font-bold font-generalsans text-off-white"
          >
            CHRIS
            <br />
            XIONG
          </motion.span>
        )}
      </motion.div>
      <motion.div className="flex justify-center" variants={shapeVariants}>
        <motion.img
          alt="logo"
          src={logo}
          className="bg-off-white w-[90px] h-[90px]"
        />
      </motion.div>
    </motion.div>
  );
};

export default PreLoader;
